import React from "react";
import LegalLayout from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="April 26, 2026">
      <p>
        Jingle Hooks ("we", "us", "our") respects your privacy. This policy explains what information we collect, how we use it, and your rights.
      </p>

      <h2>1. Information we collect</h2>
      <ul>
        <li><strong>Account data</strong> — name, email address, profile picture (provided via Google OAuth).</li>
        <li><strong>Usage data</strong> — scripts, prompts, generated jingles, credit balance, subscription tier.</li>
        <li><strong>Payment metadata</strong> — transaction IDs, amounts, plan purchased (handled by Razorpay; we do not store card details).</li>
        <li><strong>Technical logs</strong> — IP address, browser type, device, timestamps (for security and rate-limiting).</li>
      </ul>

      <h2>2. How we use your information</h2>
      <ul>
        <li>Generate jingles, store your library, and deliver our core service.</li>
        <li>Charge subscriptions, top-ups, and manage credits.</li>
        <li>Send service-related notifications (invoices, failed payments, security alerts).</li>
        <li>Improve our models and features (in aggregate, anonymised form only).</li>
      </ul>

      <h2>3. Third-party processors</h2>
      <p>
        We use industry-standard third-party services to deliver our product: Google (authentication), Razorpay (payments), cloud AI providers (music & lyrics generation), and cloud infrastructure (hosting). These partners are contractually bound to protect your data.
      </p>

      <h2>4. Data retention</h2>
      <p>
        Your jingles and account data are retained until you delete your account. Generated audio files older than 12 months may be archived to cold storage. Backups are retained for 30 days.
      </p>

      <h2>5. Your rights</h2>
      <p>
        You have the right to access, correct, export, or delete your personal data at any time. Email <a href="mailto:support@jinglehooks.com">support@jinglehooks.com</a> to exercise these rights.
      </p>

      <h2>6. Security</h2>
      <p>
        We use encrypted transport (TLS 1.2+), secure cookies, and access-controlled storage. No system is perfectly secure — if you suspect compromise, email us immediately.
      </p>

      <h2>7. Cookies</h2>
      <p>
        We use a single HTTP-only session cookie for authentication. See our <a href="/cookies">Cookie Policy</a>.
      </p>

      <h2>8. Contact</h2>
      <p>
        <strong>Email:</strong> <a href="mailto:support@jinglehooks.com">support@jinglehooks.com</a><br />
        <strong>Jurisdiction:</strong> India
      </p>
    </LegalLayout>
  );
}
